import { activeStatuses } from "@p81-common/shell-core-js";

export const isSubscriptionActive = (subscriptionStatus: string): boolean => {
  return activeStatuses.includes(subscriptionStatus);
};
